import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';

function SmartInput(props) {

	//pass in prop to update state of parent for FITB

	const defaultProps = {
	    options: ['est', 'sur', "fuck"],
	    getOptionLabel: (option) => option,
	  };

	return (
		<Autocomplete
		key={props.index}
		onChange={(event, value) => props.updateChoices(value, props.index)}
		{...defaultProps}
		options={props.options == null ? ["props.options", "is", "null"] : props.options}
		id="auto-complete"
        autoComplete
        includeInputInList
        renderInput={(params) => (
          <TextField {...params} label="Answer" variant="filled" />
        )}
      />


	)
}

export default SmartInput